import React, { useState } from 'react';
import { Container, Grid, Card, CardMedia, CardContent, Typography, Box, Avatar, Divider, Button } from '@mui/material';
import Slider from 'react-slick';
import shreyas from "../assets/shreyas-lohiya-thumb.webp";
import Krishna from "../assets/krishna-agrawal-thumb.webp";
import devya from "../assets/devya-rustagi-thumb.webp";
import mridul from "../assets/mridul-manya-anand-thumb.webp";
import ayush from "../assets/ayush-naugraiya-thumb.webp";
import arghyadeep from "../assets/arghyadeep-dutta-thumb.webp";
import shreyasphoto from "../assets/shreyas-lohiya-photo.webp";
import Krishnaphoto from "../assets/krishna-agrawal-photo.webp";
import devyaphoto from "../assets/devya-rustagi-photo.webp";
import mridulphoto from "../assets/mridul-manya-anand-photo.jpg";
import ayushphoto from "../assets/ayush-naugraiya-thumb.webp";
import arghyadeepphoto from "../assets/arghyadeep-dutta-thumb.webp";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { styled } from '@mui/system';

const StyledSlider = styled(Slider)(({ theme }) => ({
  '& .slick-prev, & .slick-next': {
    zIndex: 1,
    width: 30,
    height: 30,
    '&:before': {
      fontSize: 30,
      color: 'black',
    },
    [theme.breakpoints.down('sm')]: {
      width: 25,
      height: 25,
      '&:before': {
        fontSize: 25,
      },
    },
  },
  '& .slick-prev': {
    left: -20,
    [theme.breakpoints.down('sm')]: {
      left: -15,
    },
  },
  '& .slick-next': {
    right: -20,
    [theme.breakpoints.down('sm')]: {
      right: -15,
    },
  },
}));

const ProjectsSection = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredCard(index);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  const cards = [
    {
      image: ayush,
      description:
        'Ayush Naugraiya, the NEET 2024 topper, shares his preparation journey with Aakash Institute. Learn about his study strategy, NCERT focus, and stress management techniques that led to his success.',
      title: "Ayush Naugraiya",
      content: "NEET 2024 Topper",
      photos: ayushphoto
    },
    {
      image: shreyas,
      description:
        'Shreyas Lohiya, a JEE (Main) 2025 aspirant, talks about his dedication and strategic preparation. Discover how his institute played a crucial role in his academic progress.',
      title: "Shreyas Lohiya",
      content: "JEE(MAIN), 2025",
      photos: shreyasphoto
    },
    {
      image: Krishna,
      description:
        'Krishna Agrawal, an aspiring JEE (Main) 2025 candidate, shares insights into his preparation methods, subject priorities, and the resources that helped him excel.',
      title: "Krishna Agrawal",
      content: "JEE(MAIN), 2025",
      photos: Krishnaphoto
    },
    {
      image: devya,
      description:
        'Devya Rastagi, a passionate engineering aspirant, discusses her journey toward JEE (Main) 2025, focusing on concept clarity, time management, and mock test strategies.',
      title: "Devya Rastagi",
      content: "JEE(MAIN), 2025",
      photos: devyaphoto
    },
    {
      image: mridul,
      description:
        'Mridul Manya Anand, a determined JEE (Main) 2025 aspirant, shares his experience of overcoming challenges, maintaining consistency, and staying motivated during preparation.',
      title: "Mridul Manya Anand",
      content: "JEE(MAIN), 2025",
      photos: mridulphoto
    },
    {
      image: arghyadeep,
      description:
        'Arghyadeep Dutta, preparing for JEE (Main) 2025, talks about his academic journey, study habits, and the importance of self-discipline in achieving high scores.',
      title: "Arghyadeep Dutta",
      content: "JEE(MAIN), 2025",
      photos: arghyadeepphoto
    },
  ];


  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <Grid container justifyContent="center" sx={{ overflowX: 'hidden', whiteSpace: 'nowrap' }}>
      <Container sx={{ marginTop: 1, marginBottom: 2 }}>
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontFamily: 'sans-serif',
            // fontSize: 20,
            fontWeight: 600,
            marginTop: { md: 5, xs: 2 },
            textAlign: 'center',
          }}
        >
          Testimonials
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{
            fontFamily: 'sans-serif',
            fontWeight: { md: 800, xs: 800 },
            marginTop: { md: 2, xs: 2 },
            marginBottom: 4,
            textAlign: 'center',
            color:'#159fdc'
          }}
        >
          Our Pride, Their Stories
        </Typography>
        <StyledSlider {...settings}>
          {cards.map((card, index) => (
            <Grid key={index} sx={{ position: 'relative', overflow: 'visible' }}>
              <Card
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                sx={{
                  transform: hoveredCard === index ? 'scale(1.05)' : 'scale(1)',
                  transition: 'transform 0.3s',
                  margin: '0 10px',
                  zIndex: hoveredCard === index ? 1 : 1,
                  position: 'relative',
                  marginBottom: 1,
                  marginTop: 1,
                  height: '380px',
                }}
              >
                <CardMedia component="img" height="200" image={card.image} alt={card.title} />
                <CardContent>
                  <Typography variant="body2" color="textSecondary" sx={{ marginTop: 2, textAlign: 'center', }}>
                    {card.description}
                  </Typography>
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      backgroundColor: "white",
                      borderRadius: 2,
                      padding: 2,
                      boxShadow: 1,
                      marginBottom: 2,
                      mt: 2
                    }}
                  >
                    <Avatar
                      src={card.image}
                      alt={card.title}
                      sx={{ width: 50, height: 50 }}
                    />
                    <Box>
                      <Typography fontWeight="bold" color="text.primary">
                        {card.title}
                      </Typography>
                      <Typography color="text.secondary">{card.content}</Typography>
                      <Divider
                        sx={{
                          width: 30,
                          height: 3,
                          backgroundColor: "#f5a623",
                          marginTop: 0.5,
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </StyledSlider>
      </Container>
      <Grid container justifyContent={"center"}>
        <Button sx={{
          bgcolor:"#f1a12e",
          color:'#ffff',
          fontWeight:'bold',
          fontSize:'20px'
        }}>
          View All Testimonials
        </Button>
      </Grid>
    </Grid>
  );
};

export default ProjectsSection;